import { render } from "./CargoUnitsPage.vue?vue&type=template&id=37c2c654&scoped=true"
import script from "./CargoUnitsPage.vue?vue&type=script&lang=js"
export * from "./CargoUnitsPage.vue?vue&type=script&lang=js"

import "./CargoUnitsPage.vue?vue&type=style&index=0&id=37c2c654&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37c2c654"]])

export default __exports__